import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { syncManifestForPath } from "../lib/pwaManifest";

/**
 * Scrolls window (and the main scroll container, if any) to top whenever the
 * route pathname changes. Mount once near the top of the router.
 *
 * Also swaps the PWA manifest between customer and admin variants so that
 * Chrome treats them as two installable apps with different scopes.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Dual-PWA: keep <link rel="manifest"> in sync with the current route
        // so install prompts and home-screen icons match the section the user
        // is in (customer vs admin).
        syncManifestForPath(pathname);

        // Defer to next frame so the new route's first paint owns the scroll.
        const id = requestAnimationFrame(() => {
            try {
                window.scrollTo({ top: 0, left: 0, behavior: "instant" });
            } catch {
                window.scrollTo(0, 0);
            }
            // Also scroll the admin <main> overflow-auto container (if present)
            const mains = document.querySelectorAll("main");
            mains.forEach((m) => {
                if (m && typeof m.scrollTo === "function") {
                    try { m.scrollTo({ top: 0, behavior: "instant" }); } catch { m.scrollTo(0, 0); }
                }
            });
        });
        return () => cancelAnimationFrame(id);
    }, [pathname]);

    return null;
}
